import styled from 'styled-components';
import { spacing, breakpoints } from 'styles/globals';
import CollectionGridItem from './CollectionGridItem';
var CollectionGrid = styled.ul.attrs(function (p) {
  return {
    role: p.role || 'list'
  };
}).withConfig({
  displayName: "CollectionGrid",
  componentId: "sc-1cn2tn0-0"
})(["display:flex;flex-wrap:wrap;margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}@media (min-width:", "){margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}}@media (min-width:", "){margin-left:-", ";margin-bottom:-", ";& > ", "{padding-left:", ";padding-bottom:", ";}}"], spacing.s, spacing.s, CollectionGridItem, spacing.s, spacing.s, breakpoints.s, spacing.m, spacing.m, CollectionGridItem, spacing.m, spacing.m, breakpoints.m, spacing.l, spacing.l, CollectionGridItem, spacing.l, spacing.l);
CollectionGrid.Item = CollectionGridItem;
export { CollectionGridItem };
export default CollectionGrid;